import React, { useState, useEffect } from 'react';

// material-ui
import { Card, Grid, Tabs, Tab, CardContent, Box, Button } from '@mui/material';

import AddOnCategoryComponent from './addon_categories/addonCategory';
import SportCourtTypeComponent from './sport_court_type/sportCourtType';
import ValuePackCategoryComponent from './value_pack_categories/valuePackCategory';
import TabButtons from 'views/components/tabButtons';


export default function Categories({
    merchantId,
    placeId,
    globalVP
}) {
    const [currentTab, setCurrentTabs] = useState(0)
    const [tabList, setTabList] = useState([
        { key: 0, label: 'Addon Category', component: <AddOnCategoryComponent merchantId={merchantId} placeId={placeId} /> },
        { key: 1, label: 'Sport Category', component: <SportCourtTypeComponent merchantId={merchantId} placeId={placeId} /> },
        { key: 2, label: 'Value Pack Category', component: <ValuePackCategoryComponent merchantId={merchantId} placeId={placeId} globalVP={globalVP} /> }
    ]);

    useEffect(() => { }, [currentTab])

    return (
        <>
            <Card style={{ width: '100%', height: 'auto', ml: 3, borderRadius: 0, paddingBottom: 0 }}>
                <CardContent sx={{ padding: 2, paddingTop: 1, '&:last-child': { paddingBottom: 0 } }}>
                    <TabButtons
                        tabList={tabList}
                        currentTab={currentTab}
                        setCurrentTabs={setCurrentTabs}
                    />
                </CardContent>
            </Card>
            <Grid item xs={12} md={12} style={{ paddingTop: 0 }}>
                <Card style={{ width: '100%', height: '100%', mb: 3, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                    <CardContent sx={{ padding: 2, paddingTop: 1 }}>
                        {tabList.find(item => item.key === currentTab)?.component}
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}